'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactDom = require('react-dom');

var _data = require('../util/data');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

// TODO  ICON 引入
//import Icon from '../icon';

var Button = (_temp = _class = function (_Component) {
  _inherits(Button, _Component);

  function Button(props) {
    _classCallCheck(this, Button);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Button).call(this, props));

    _this._clickHandle = function (e) {
      var buttonNode = (0, _reactDom.findDOMNode)(_this);
      _this.clearButton();
      _this.clickedTimeout = setTimeout(function () {
        return buttonNode.className += ' ' + _this.props.prefixCls + '-btn-clicked';
      }, 10);
      clearTimeout(_this.timeout);
      _this.timeout = setTimeout(function () {
        return _this.clearButton();
      }, 500);

      // 同时支持两种点击事件 优先clickAction, 第一个参数传出去可让 button 调用 loading 方法.
      _this.props.onClick.call(_this.props, _this, e);
    };

    _this._mouseUpHandle = function (e) {
      (0, _reactDom.findDOMNode)(_this).blur();
      if (_this.props.onMouseUp) {
        _this.props.onMouseUp(e);
      }
    };

    _this.clearButton = function () {
      var button = (0, _reactDom.findDOMNode)(_this);
      button.className = button.className.replace(' ' + _this.props.prefixCls + '-btn-clicked', '');
    };

    _this.loading = function () {
      var flag = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
      return new Promise(function ($return, $error) {
        return Promise.resolve(this.setStateAsync({ loading: flag })).then(function ($await_1) {
          return $return();
        }.$asyncbind(this, $error), $error);
      }.$asyncbind(_this));
    };

    _this.setStateAsync = function (newState) {
      return new Promise(function (resolve) {
        return _this.setState(newState, resolve);
      });
    };

    _this.state = {
      loading: props.loading || false
    };
    return _this;
  }

  _createClass(Button, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // 卸载后将延时器清掉
      if (this.clickedTimeout) {
        clearTimeout(this.clickedTimeout);
      }
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if ('loading' in props) {
        this.setState({ loading: props.loading || false });
      }
    }

    // 添加点击后效果 并 触发响应事件


    // chrome 上点击后按钮自动获得焦点

  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var loading = this.state.loading;
      var _props = this.props;
      var label = _props.label;
      var type = _props.type;
      var htmlType = _props.htmlType;
      var icon = _props.icon;
      var iconRight = _props.iconRight;
      var style = _props.style;
      var shape = _props.shape;
      var size = _props.size;
      var disabled = _props.disabled;
      var className = _props.className;
      var children = _props.children;
      var domProps = _props.domProps;


      var prefixCls = this.props.prefixCls + "-btn";
      // large => lg
      // small => sm
      var sizeCls = {
        large: 'lg',
        small: 'sm',
        xsmall: 'xs'
      }[size] || '';

      var kids = label || children;

      var classes = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, prefixCls, true), _defineProperty(_classNames, prefixCls + '-' + shape, shape !== 'default'), _defineProperty(_classNames, prefixCls + '-' + type, type), _defineProperty(_classNames, prefixCls + '-disabled', disabled), _defineProperty(_classNames, prefixCls + '-' + sizeCls, sizeCls), _defineProperty(_classNames, prefixCls + '-mix-icon', kids && !loading && icon), _defineProperty(_classNames, prefixCls + '-icon-only', !kids && icon), _defineProperty(_classNames, prefixCls + '-icon-right', kids && (loading || icon) && iconRight), _defineProperty(_classNames, prefixCls + '-loading', loading), _defineProperty(_classNames, className, !!className), _classNames));

      var iconType = loading ? 'loading' : icon;

      var iconDom = iconType && _react2.default.createElement('i', { className: (_data.IconPrefixCls + ' ' + _data.IconPrefixCls + '-' + iconType).trim() });

      return _react2.default.createElement(
        'button',
        _extends({ style: style
        }, domProps, {
          type: htmlType || 'button',
          className: classes,
          disabled: disabled,
          onMouseUp: this._mouseUpHandle,
          onClick: loading ? null : this._clickHandle,
          ref: 'button' }),
        !iconRight ? iconDom : null,
        _react2.default.createElement(
          'span',
          null,
          kids
        ),
        iconRight ? iconDom : null
      );
    }

    /**
     * 清除点击的效果
     */


    /**
     * 触发/关闭 按钮的 loading 转圈
     * @param flag 是否触发转圈,默认为true
     */


    /**
     * Promise 模式的 React#setState
     * @param {object} newState 传给 React#setState 的参数
     * @returns {Promise|Promise<T>} 返回的 Promise 会在 setState 的 callback 被调用时完成
     */

  }]);

  return Button;
}(_react.Component), _class.propTypes = {
  prefixCls: _propTypes2.default.string,
  shape: _propTypes2.default.oneOf(['default', 'circle', 'circle-outline', 'no-outline']),
  type: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['large', 'default', 'small', 'xsmall']),
  loading: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  label: _propTypes2.default.any,
  htmlType: _propTypes2.default.oneOf(['submit', 'button', 'reset']),
  icon: _propTypes2.default.string,
  iconRight: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  domProps: _propTypes2.default.object
}, _class.defaultProps = {
  prefixCls: 'mt',
  shape: 'default', // 设置按钮形状，可选值为 default|circle|circle-outline|no-outline 或者不设
  type: null, // 设置按钮类型，可选值为 default|primary|success|warning|danger 或者不设
  size: null, // 设置按钮大小，可选值为 xsmall|small|default|large 或者不设
  loading: false, // 设置按钮载入状态
  disabled: false, // 设置禁用状态
  label: '', // 按钮的文字
  htmlType: 'button', // 设置 button 原生的 type 值，可选值请参考 HTML 标准
  icon: null, // 设置按钮的图标类型
  iconRight: false, // 设置图标在文字的右边与否
  onClick: _data.noop, // click 事件的 handler
  domProps: {} }, _temp);
exports.default = Button;